import React, { ReactNode } from 'react'
import { Control, Controller, RegisterOptions } from 'react-hook-form'

import { CheckboxBase } from '../../forms/checkbox/CheckboxBase'

type CheckboxProps = {
  control: Control<any, any>
  rules: Omit<
    RegisterOptions<any, any>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >
  name: string
  label?: ReactNode
  disabled?: boolean
}

const Checkbox = ({ label, disabled, name, control, rules }: CheckboxProps) => {
  return (
    <Controller
      control={control}
      rules={rules}
      render={({ field }) => {
        return (
          <CheckboxBase
            name={name}
            label={label}
            disabled={disabled}
            checked={field.value}
            onChange={(e) => {
              field.onChange(e.target.checked)
            }}
          />
        )
      }}
      name={name}
    />
  )
}

export default Checkbox
